// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qV1WL","col":"styles_col__21nqH"};